

































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import { Prop } from 'vue-property-decorator'
import AdminCampaignCancellationDialog
  from '@/modules/base-campaign/components/admin/AdminCampaignCancellationDialog.vue'
import { ContentCampaignResourceTypeInAdmin } from '@/modules/content-campaign/models/content-campaign-resource.model'
import { AdminContentCampaignService } from '@/modules/content-campaign/services/admin-content-campaign.service'
import { CampaignStatus } from '@/modules/base-campaign/models/base-campaign-resource.model'
import {
  AdminContentCampaignSetToCanceledUseCase
} from '@/modules/content-campaign/use-cases/admin/admin-content-campaign-set-to-canceled.use-case'
import AdminContentCampaignCompleteButton
  from '@/modules/content-campaign/components/admin/AdminContentCampaignCompleteButton.vue'

@Component({
  components: {
    AdminContentCampaignCompleteButton,
    AdminCampaignCancellationDialog,
    BaseButton
  }
})
export default class AdminContentCampaignTabularActions extends Vue {
  constructor(
    private readonly service: AdminContentCampaignService,
    private readonly cancellationUseCase: AdminContentCampaignSetToCanceledUseCase
  ) {
    super()
  }

  @Prop() contentCampaign: ContentCampaignResourceTypeInAdmin
  @Prop({ default: '' }) label: string
  private draftStatus = CampaignStatus.DRAFT
  private cancellationDialog = false


  get campaignData() {
    return this.contentCampaign.data
  }

  onClick() {
    this.service.destroy(this.contentCampaign.data.id)
  }

  get status() {
    let nonRejected = [CampaignStatus.CANCELLED, CampaignStatus.COMPLETED]
    return !nonRejected.includes(this.campaignData.status)
  }
}
